import type { ListLocalMarketCartItemResponse } from '@generated/auth/types.gen';

import type {
  CartOption,
  CartProduct,
  CartShop,
} from '../_components/CartShopGroup';

type CartItemDto = NonNullable<
  ListLocalMarketCartItemResponse['contents']
>[number];

const transformOptions = (item: CartItemDto): CartOption[] => {
  const options: CartOption[] = (item.options ?? []).map((opt) => ({
    cartItemOptionId: opt.cartItemId ?? '',
    productOptionItemIds: opt.productOptionItemIds ?? [],
    optionName: opt.optionName ?? '기본',
    quantity: opt.quantity ?? 1,
    price:
      (item.currentPrice ?? item.regularPrice ?? 0) + (opt.extraPrice ?? 0),
    extraPrice: opt.extraPrice ?? 0,
    soldOutYN: opt.soldOutYN ?? false,
  }));

  if (options.length === 0) {
    options.push({
      cartItemOptionId: '',
      productOptionItemIds: [],
      optionName: '기본',
      quantity: 1,
      price: item.currentPrice ?? item.regularPrice ?? 0,
      extraPrice: 0,
      soldOutYN: false,
    });
  }

  return options;
};

const transformCartItem = (item: CartItemDto): CartProduct => ({
  mallProductId: item.mallProductId ?? '',
  productName: item.productName ?? '상품',
  mainImageUrl: item.mainImageUrl ?? '',
  checked: true,
  soldOutYN: item.soldOutYN ?? false,
  regularPrice: item.regularPrice ?? 0,
  currentPrice: item.currentPrice ?? item.regularPrice ?? 0,
  discountPrice: item.discountPrice ?? 0,
  deliveryFee: item.deliveryFee ?? 0,
  freeShippingAvailable: item.freeShippingAvailable ?? false,
  freeShippingAmount: item.freeShippingAmount ?? 0,
  options: transformOptions(item),
});

export const transformCartResponse = (
  context?: ListLocalMarketCartItemResponse,
): CartShop[] => {
  if (!context?.contents?.length) return [];

  const vendorMap = new Map<
    string,
    { vendorName: string; govCodeName: string; items: CartItemDto[] }
  >();

  for (const item of context.contents) {
    const vendorId = item.mallVendorId ?? 'unknown';
    if (!vendorMap.has(vendorId)) {
      vendorMap.set(vendorId, {
        vendorName: item.vendorName ?? vendorId,
        govCodeName: item.govCodeName ?? '',
        items: [],
      });
    }
    vendorMap.get(vendorId)!.items.push(item);
  }

  return Array.from(vendorMap.entries()).map(
    ([vendorId, { vendorName, govCodeName, items }]) => ({
      mallVendorId: vendorId,
      govCodeName,
      vendorName,
      checked: true,
      products: items.map(transformCartItem),
    }),
  );
};
